export default __webpack_public_path__ + "static/media/arrow_left.510a0f17.svg";